import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    Grid,
    Avatar,
    Flex,
    Text,
    Select,
    Divider,
    useToast,
    Spinner,
    Box,
    Heading,
    HStack,
    Radio,
    RadioGroup,
    SimpleGrid,
    Stack,
    Switch,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { useEffect, useState } from 'react';
  import { getCookie } from 'cookies-next';
import { useJwt } from 'react-jwt';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import axiosInstance from 'api/AxiosInstance';
import Activar2FA from '../TwoView/Activar2fa'; // Ajusta la ruta si es distinta
import { AppBackgroundTone, useAppThemePreference } from 'contexts/ThemePreferenceContext';

// En tu componente:


  const municipiosPorEntidad: Record<string, string[]> = {
    Tlaxcala: ['Tlaxcala', 'Apizaco', 'Chiautempan', 'Huamantla'],
    Puebla: ['Puebla', 'Tehuacán', 'Atlixco', 'Cholula'],
    'CDMX': ['Álvaro Obregón', 'Coyoacán', 'Iztapalapa'],
  };
  
  const entidades = Object.keys(municipiosPorEntidad);
  const ocupaciones = ['Arquitecto', 'Ingeniero Civil', 'Abogado', 'Contador', 'Doctor', 'Comerciante', 'Empleado Público', 'Estudiante', 'Otro'];
  const escolaridades = ['Primaria', 'Secundaria', 'Preparatoria', 'Licenciatura', 'Maestría', 'Doctorado'];
  const nacionalidades = ['Mexicana', 'Estadounidense', 'Colombiana', 'Otra'];
  
  export default function PerfilUsuarioModal({
    isOpen,
    onClose,
  }: {
    isOpen: boolean;
    onClose: () => void;
  }) {
    const token = getCookie('token');
    const user = useSelector((state: RootState) => state.auth.user);

    const { decodedToken } = useJwt(token);
    const toast = useToast();
    const themePreference = useAppThemePreference();
    const modalBg = useColorModeValue('white', '#1e1519');
    const cardBg = useColorModeValue('white', 'whiteAlpha.100');
    const borderColor = useColorModeValue('#e2e8f0', 'whiteAlpha.200');
    const mutedText = useColorModeValue('gray.500', 'whiteAlpha.700');
    const [perfil, setPerfil] = useState<any | null>(null);
    const [foto, setFoto] = useState<string | ArrayBuffer | null>(null);
    const [loading, setLoading] = useState(false);
  
    const perfilVacio = {
      nombre: '',
      correo: '',
      telefono: '',
      curp: '',
      rfc: '',
      genero: 'Masculino',
      estadoCivil: 'Soltero',
      fechaNacimiento: '1990-01-01',
      nacionalidad: 'Mexicana',
      ocupacion: 'Estudiante',
      escolaridad: 'Licenciatura',
      direccion: '',
      entidad: 'Tlaxcala',
      municipio: 'Tlaxcala',
      codigoPostal: '',
      imagen: '',
    };
  
    const fetchPerfil = async () => {
        setLoading(true);
        try {
          const res = await axiosInstance.get('/usuario/perfil/'+user?.id); // no uses /api si ya lo tienes en baseURL
          setPerfil(res.data);
          setFoto(res.data.imagen || '');
        } catch (error) {
          setPerfil(perfilVacio);
          setFoto('');
        } finally {
          setLoading(false);
        }
      };
  
    useEffect(() => {
      if (isOpen) fetchPerfil();
    }, [isOpen]);
  
    const handleFotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => setFoto(reader.result);
        reader.readAsDataURL(file);
      }
    };
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { name, value } = e.target;
      if (name === 'entidad') {
        setPerfil((prev: any) => ({
          ...prev,
          entidad: value,
          municipio: municipiosPorEntidad[value]?.[0] || '',
        }));
      } else {
        setPerfil((prev: any) => ({ ...prev, [name]: value }));
      }
    };
  
    const guardarCambios = async () => {
        const camposRequeridos = [
          'nombre',
          'correo',
          'curp',
          'rfc',
          'fechaNacimiento',
          'entidad',
          'municipio',
        ];
      
        const faltantes = camposRequeridos.filter((campo) => !perfil[campo]?.trim());
      
        if (faltantes.length > 0) {
          toast({
            title: 'Faltan campos obligatorios',
            description: `Debes completar: ${faltantes.join(', ')}`,
            status: 'warning',
            duration: 4000,
            isClosable: true,
          });
          return;
        }
      
        try {
          const method = perfil?.id ? 'put' : 'post';
          let endpoint = '/usuario/perfil'; // usa ruta protegida
      
          const payload = {
            ...perfil,
            imagen: foto,
            ...(method === 'post' && user?.id ? { usuarioId: user.id } : {}),
          };
      
          if (method === 'put') {
            endpoint=endpoint+'/'+user?.id

            await axiosInstance.put(endpoint, payload);
          } else {
            await axiosInstance.post(endpoint, payload);
          }
      
          toast({
            title: `Perfil ${method === 'post' ? 'creado' : 'actualizado'} correctamente`,
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
      
          onClose();
        } catch (error: any) {

        console.log(error)
          toast({
            title: 'Error al guardar el perfil',
            description: error.response?.data?.error || 'Ocurrió un error inesperado.',
            status: 'error',
            duration: 3000,
            isClosable: true,
          });
        }
      };
      
    if (loading || !perfil) {
      return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay />
          <ModalContent p={10} textAlign="center">
            <Spinner size="xl" />
          </ModalContent>
        </Modal>
      );
    }
  
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent bg={modalBg}>
          <ModalHeader>Mi Perfil</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={8}>
            {/* FOTO CENTRADA */}
            <Flex direction="column" align="center" justify="center" w="100%" mb={6}>
              <Avatar size="2xl" name={perfil.nombre} src={foto as string} boxShadow="lg" mb={3} />
              <Button as="label" colorScheme="blue" cursor="pointer">
                Cambiar Foto
                <Input type="file" hidden accept="image/*" onChange={handleFotoChange} />
              </Button>
              <Text fontSize="sm" color={mutedText} mt={2}>Max. 2MB - JPG/PNG</Text>
            </Flex>
  
            <Divider mb={4} />
            <Text fontSize="lg" fontWeight="semibold" mb={2}>Datos Generales</Text>
  
            <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
              <FormControl><FormLabel>Nombre completo</FormLabel><Input name="nombre" value={perfil.nombre} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Correo electrónico</FormLabel><Input name="correo" value={perfil.correo} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Teléfono</FormLabel><Input name="telefono" value={perfil.telefono} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Fecha de nacimiento</FormLabel><Input type="date" name="fechaNacimiento" value={perfil.fechaNacimiento} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>CURP</FormLabel><Input name="curp" value={perfil.curp} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Género</FormLabel><Select name="genero" value={perfil.genero} onChange={handleChange}><option>Masculino</option><option>Femenino</option><option>Otro</option></Select></FormControl>
              <FormControl><FormLabel>Estado Civil</FormLabel><Select name="estadoCivil" value={perfil.estadoCivil} onChange={handleChange}><option>Soltero</option><option>Casado</option><option>Divorciado</option></Select></FormControl>
              <FormControl><FormLabel>Dirección</FormLabel><Input name="direccion" value={perfil.direccion} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Código Postal</FormLabel><Input name="codigoPostal" value={perfil.codigoPostal} onChange={handleChange} /></FormControl>
            </Grid>
  
            <Divider my={6} />
            <Text fontSize="lg" fontWeight="semibold" mb={2}>Datos del Solicitante</Text>
  
            <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
              <FormControl><FormLabel>RFC</FormLabel><Input name="rfc" value={perfil.rfc} onChange={handleChange} /></FormControl>
              <FormControl><FormLabel>Ocupación</FormLabel><Select name="ocupacion" value={perfil.ocupacion} onChange={handleChange}>{ocupaciones.map(o => <option key={o}>{o}</option>)}</Select></FormControl>
              <FormControl><FormLabel>Escolaridad</FormLabel><Select name="escolaridad" value={perfil.escolaridad} onChange={handleChange}>{escolaridades.map(e => <option key={e}>{e}</option>)}</Select></FormControl>
              <FormControl><FormLabel>Nacionalidad</FormLabel><Select name="nacionalidad" value={perfil.nacionalidad} onChange={handleChange}>{nacionalidades.map(n => <option key={n}>{n}</option>)}</Select></FormControl>
              <FormControl><FormLabel>Entidad</FormLabel><Select name="entidad" value={perfil.entidad} onChange={handleChange}>{entidades.map(e => <option key={e}>{e}</option>)}</Select></FormControl>
              <FormControl><FormLabel>Municipio</FormLabel><Select name="municipio" value={perfil.municipio} onChange={handleChange}>{municipiosPorEntidad[perfil.entidad]?.map(m => <option key={m}>{m}</option>)}</Select></FormControl>
            </Grid>
  
            <Box mt={8} borderTop="1px solid" borderColor={borderColor} pt={6}>
  <Heading fontSize="md" mb={2}>
    Apariencia del sistema
  </Heading>
  <Text fontSize="sm" color={mutedText} mb={4}>
    Esta preferencia se guarda para tu usuario en este equipo.
  </Text>

  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={6}>
    <Box p={4} border="1px solid" borderColor={borderColor} borderRadius="18px" bg={cardBg}>
      <Flex justify="space-between" align="center" gap={4}>
        <Box>
          <Text fontWeight="bold">Modo oscuro</Text>
          <Text fontSize="sm" color={mutedText}>Cambia colores base, textos y superficies compatibles.</Text>
        </Box>
        <Switch
          colorScheme="red"
          isChecked={themePreference.colorMode === 'dark'}
          onChange={(event) => themePreference.setColorModePreference(event.target.checked ? 'dark' : 'light')}
        />
      </Flex>
    </Box>

    <Box p={4} border="1px solid" borderColor={borderColor} borderRadius="18px" bg={cardBg}>
      <Text fontWeight="bold" mb={2}>Color global de fondo</Text>
      <RadioGroup
        value={themePreference.backgroundTone}
        onChange={(value) => themePreference.setBackgroundTone(value as AppBackgroundTone)}
      >
        <Stack spacing={3}>
          <Radio value="white" colorScheme="red">
            <HStack>
              <Box w="22px" h="22px" borderRadius="full" bg="#ffffff" border="1px solid #d8cfc5" />
              <Text>Blanco (#ffffff)</Text>
            </HStack>
          </Radio>
          <Radio value="neutral" colorScheme="red">
            <HStack>
              <Box w="22px" h="22px" borderRadius="full" bg="#f7f4ee" border="1px solid #d8cfc5" />
              <Text>Neutro suave (#f7f4ee)</Text>
            </HStack>
          </Radio>
          <Radio value="warm" colorScheme="red">
            <HStack>
              <Box w="22px" h="22px" borderRadius="full" bg="#f4efe8" border="1px solid #d8cfc5" />
              <Text>Calido original (#f4efe8)</Text>
            </HStack>
          </Radio>
        </Stack>
      </RadioGroup>
    </Box>
  </SimpleGrid>

  <Button size="sm" variant="outline" onClick={themePreference.resetPreferences}>
    Restaurar apariencia por defecto
  </Button>
</Box>

            <Box mt={8} borderTop="1px solid" borderColor={borderColor} pt={6}>
  <Heading fontSize="md" mb={2}>
    Seguridad adicional
  </Heading>
  <Text fontSize="sm" color={mutedText} mb={4}>
    Puedes activar la autenticación en dos pasos (2FA) para mejorar la seguridad de tu cuenta.
  </Text>
  <Activar2FA />
</Box>

          </ModalBody>
  
          <ModalFooter>
            <Button colorScheme="green" mr={3} onClick={guardarCambios}>Guardar Cambios</Button>
            <Button variant="ghost" onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
  
